<rs-modal #modal
  (show)="show($event)"
  (submit)="submit()"
  [config]="modalConfig">

  @if (options?.selectedProcedures?.length > 0) {
    <div class="selected-summary p-4 bg-white mb-3">
      <div class="fw-700 fs-16 mb-2">Selected Services</div>
      @for (item of options.selectedProcedures; track item) {
        <div class="selected-summary-item d-flex justify-content-between align-items-center py-2">
          <div class="flex-grow-1 text-trim-2">{{ item.name | translate }}</div>
          <button type="button" (click)="removeProcedure(item)" class="rs-btn-link fw-700 ms-3">Remove</button>
        </div>
      }
    </div>
  }

  <app-search-procedures [(searchMode)]="searchMode"
    [locationId]="options.locationId"
    [procedureSearchConfig]="orgLayoutConfig?.config?.misc"
    [(selectedProcedures)]="options.selectedProcedures"
    (selectedProceduresChange)=selectedProceduresChanged($event)
    (toggleContactMeModal)="showContactMeModal($event)">
  </app-search-procedures>

  @if (!searchMode) {
    <div class="procedures-list">
      @for (procedure of proceduresList; track procedure; let i = $index) {
        <div class="p-4 bg-white w-100 color-secondary mb-3">
          <button
            type="button"
            (click)="toggleCategory(procedure, i)"
            class="rs-btn-link d-flex justify-content-between align-items-center btn-inner w-100 fw-700 fs-18 category-toggle"
            [attr.aria-expanded]="expandedCategoryIndex === i"
            [attr.aria-controls]="'category-panel-' + procedure.id"
            [class.is-expanded]="expandedCategoryIndex === i">
            <span>{{ procedure.name | translate }}</span>
            <span class="d-flex align-items-center gap-2">
              @if (procedure?.selected?.length > 0) {
                <span class="selection-badge">{{ procedure.selected.length }} selected</span>
              }
              <span class="category-chevron" aria-hidden="true"></span>
            </span>
          </button>
          @if (expandedCategoryIndex === i) {
            <div [id]="'category-panel-' + procedure.id">
            @if (checkboxFormArray && expandedProcedureGroups?.length) {
              <div>
                @for (checkbox of checkboxFormArray.controls; track checkbox; let j = $index) {
                  <div class="bottom-border pt-4 pb-2">
                    <div class="selected-item d-flex justify-content-between align-items-center">
                      <div class="selected-item-title align-items-top">
                        <rs-checkbox ngDefaultControl
                          [id]="'procedure-group-' + expandedProcedureGroups[j].id"
                          [label]="expandedProcedureGroups[j].name | translate"
                          [formControl]="checkbox"
                          (change)="selectProcedureGroup($event, expandedProcedureGroups[j])">
                        </rs-checkbox>
                        @if (expandedProcedureGroups[j].procedures.length > 1) {
                          <button
                            type="button"
                            (click)="expandedProcedureGroups[j].open = !expandedProcedureGroups[j].open"
                            class="rs-btn-link d-flex align-items-center fw-700 stack">
                            {{ expandedProcedureGroups[j].procedures.length }}
                            {{ expandedProcedureGroups[j].procedures.length === 1 ? 'procedure' : 'procedures' }}
                          </button>
                        }
                      </div>
                      @if (expandedProcedureGroups[j].procedures.length > 1 && expandedProcedureGroups[j].open) {
                        <div class="pulldown-menu p-3">
                          <div class="fw-700 fs-18 mb-3">Procedures in this group</div>
                          @for (child of expandedProcedureGroups[j].procedures; track child) {
                            <div>{{ child.name | translate }}</div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            } @else if (!expandedProcedureGroups) {
              <div class="pt-3 text-center">Loading...</div>
            } @else {
              <div class="pt-3">No procedures available for this category.</div>
            }
            </div>
          }
        </div>
      }
    </div>
  }
</rs-modal>